var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorldYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3521 47.7522C16.1812 43.1022 14.0625 34.6522 14.0625 25.0001C14.0625 15.348 16.1812 6.89805 19.3521 2.24805",
    stroke: "#E99F0C",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3521 47.7522C16.1812 43.1022 14.0625 34.6522 14.0625 25.0001C14.0625 15.348 16.1812 6.89805 19.3521 2.24805",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6477 47.7522C33.8185 43.1022 35.9373 34.6522 35.9373 25.0001C35.9373 15.348 33.8185 6.89805 30.6477 2.24805",
    stroke: "#E99F0C",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6477 47.7522C33.8185 43.1022 35.9373 34.6522 35.9373 25.0001C35.9373 15.348 33.8185 6.89805 30.6477 2.24805",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6145 23.4375H48.4374",
    stroke: "#E99F0C",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6145 23.4375H48.4374",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2478 10.9375H43.7499",
    stroke: "#E99F0C",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2478 10.9375H43.7499",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 35.9375H45.7291",
    stroke: "#E99F0C",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 35.9375H45.7291",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4374 25.0002C48.4451 30.061 46.8072 34.9871 43.7707 39.0357L48.4374 48.4377L35.9374 45.7294C26.6281 50.642 15.1856 48.7465 7.95781 41.0943C0.729979 33.4422 -0.510415 21.9103 4.92475 12.8961C10.3599 3.88188 21.1375 -0.403694 31.2786 2.41682C41.4197 5.23733 48.4369 14.4721 48.4374 24.9982V25.0002Z",
    stroke: "#E99F0C",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4374 25.0002C48.4451 30.061 46.8072 34.9871 43.7707 39.0357L48.4374 48.4377L35.9374 45.7294C26.6281 50.642 15.1856 48.7465 7.95781 41.0943C0.729979 33.4422 -0.510415 21.9103 4.92475 12.8961C10.3599 3.88188 21.1375 -0.403694 31.2786 2.41682C41.4197 5.23733 48.4369 14.4721 48.4374 24.9982V25.0002Z",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldYellow);
export default __webpack_public_path__ + "static/media/world-yellow.3cf4c7c25235fcedac7cb178b3617b4e.svg";
export { ForwardRef as ReactComponent };